import Block from '@shared/components/ui/Block';
import { waveSquaresKeyframes } from '@shared/styles/waveSquaresKeyframes';
import styled, { css } from 'styled-components';

export const GhostBlock = styled(Block)<{ $animated?: boolean }>`
    height: 8px;
    border-radius: 2px;
    background: -webkit-gradient(
        linear,
        left top,
        right top,
        color-stop(8%, ${({ theme }) => theme.colors.uNavy20}),
        color-stop(18%, ${({ theme }) => theme.colors.uNavy40}),
        color-stop(33%, ${({ theme }) => theme.colors.uNavy20})
    );
    background: ${({ theme }) =>
        css`linear-gradient(to right, ${theme.colors.uNavy20} 8%, ${theme.colors.uNavy40} 18%, ${theme.colors.uNavy20} 33%)`};
    background-size: 1000px 100px;

    ${({ $animated = true, theme }) =>
        $animated
            ? css`
                  animation: ${waveSquaresKeyframes} 2s infinite ease-out;
              `
            : css`
                  background: ${theme.colors.uNavy10};
              `}
`;
